<template>
  <div class="cgs-worksheet-createRow">
    <div class="cgs-createRow-header">
      <van-nav-bar :border="true" title="添加记录">
        <template #left>
          <span class="iconfont cgsIcon-houtui" @click="goBack"></span>
        </template>
        <template #right>
          <van-popover v-model="showMoreTool" trigger="click" placement="bottom-end" :actions="actions"
            @select="selectedMore">
            <template #reference>
              <span class="iconfont cgsIcon-gengduocaozuo"></span>
            </template>
          </van-popover>
        </template>
      </van-nav-bar>
    </div>
    <div class="cgs-createRow-content">
      <v-form-render ref="vFormRef" :form-json="formJson" :form-data="formData" :option-data="optionData"
        class="vFormContent"></v-form-render>
    </div>
    <div class="cgs-createRow-footer">
      <van-button type="info" style="width: 100%" :loading="!formStatus" :disabled="!formStatus" @click="submitForm">提交
      </van-button>
    </div>
  </div>
</template>

<script>
import { NavBar, Button, Popover } from "vant";
import { getWorksheetInfo, addRow, addShortcut, getShortcut, delShortcut } from "@/api/application";
import { getUserAuthority } from "@/util/author"
import "@/assets/style/css/vForm.css";
export default {
  components: {
    vanNavBar: NavBar,
    vanButton: Button,
    vanPopover: Popover,
  },
  data() {
    return {
      formJson: {},
      formData: {},
      optionData: {},
      worksheetDetail: {},
      formStatus: false,
      fastEntryAuthor: false,
      showMoreTool: false,
      actions: [{ text: "设置快捷入口", id: "add" }],
      ShortcutShow: false,
      id: '',
    };
  },
  created() {
    window.vformUploadUrlPrefix = process.env.VUE_APP_BASEURL;
    this.compareShortcut()
  },
  mounted() {
    this.setRowAuth()
    this.init();
  },
  computed: {
    worksheetId: {
      get() {
        return this.$route.params.worksheetId;
      },
      set() { },
    },
  },
  methods: {
    async init() {
      // this.wholeLoading = true
      try {
        let result = await getWorksheetInfo(this.worksheetId);
        this.worksheetDetail = result.data;
        if ("config" in this.worksheetDetail) {
          let config =
            this.worksheetDetail.config === ""
              ? []
              : JSON.parse(this.worksheetDetail.config);
          config.formConfig.labelPosition = "top";
          this.$refs.vFormRef.setFormJson(config);
          setTimeout(() => {
            this.formStatus = true;
          }, 1000);
        }
      } catch (e) {
        console.error(e);
      } finally {
        // this.wholeLoading = false
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    async selectedMore(action) {
      if (this.fastEntryAuthor) {
        switch (action.id) {
          case "add":
            let a = 'CREATE';
            let result = await addShortcut({
              sheetId: this.$route.params.worksheetId,
              url: this.$route.path,
              linkType: a,
            })
            if (result) {
              this.$Notify({ type: "success", message: "设置成功" });
              this.goBack();
            } else {
              this.$Notify({ type: "danger", message: "设置失败" });
            }
            break;
          case "del":
            let d = 'CREATE'
            let res = await delShortcut({
              sheetId: this.$route.params.worksheetId,
              url: this.$route.path,
              linkType: d,
            })
            if (res) {
              this.$Notify({ type: "success", message: "取消成功" });
              this.goBack();
            } else {
              this.$Notify({ type: "danger", message: "取消失败" });
            }
        }
      } else {
        this.$Notify({ type: "danger", message: "没有权限,请联系相关人员" });
      }

    },
    setRowAuth() {
      let appAuth = getUserAuthority()
      if (appAuth && appAuth.operatingAuthorities) {
        let _operAuth = appAuth.operatingAuthorities
        if (_operAuth.includes("MANAGE_BACKEND")) {
          this.fastEntryAuthor = true;
        }
      }
    },
    async submitForm() {
      this.$Toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      let formData = await this.$refs.vFormRef.getFormData();
      let result = await addRow({
        worksheetId: this.worksheetId,
        data: formData,
      });
      if (result) {
        this.$Notify({ type: "success", message: "提交成功" });
        this.goBack();
      } else {
        this.$Notify({ type: "danger", message: "提交失败,检查必填项" });
      }
      this.$Toast.clear();
    },
    async compareShortcut(){
        let ShortcutList = await getShortcut()
        let list = ShortcutList.data
        list.forEach(data => {
            let url = data.url;
            if( this.$route.path === url){
                this.actions[0].text = "取消快捷入口"
                this.actions[0].id = "del"
            }
        });
    }
  },
};
</script>

<style scoped>
.cgs-worksheet-createRow {
  /* background: #f5f5f5; */
  display: flex;
  flex-direction: column;
}

/* .cgs-appPage-header{
    color: #fff;
} */
.cgs-createRow-content {
  /* flex-grow: 1; */
  flex: 1;
  overflow: hidden;
  padding: 10px;
  overflow-y: auto;
}

.cgs-createRow-footer {
  height: 50px;
  padding: 10px;
}
</style>
<style>
</style>